<template lang="html">
  <div class="hardwareDesign">
    <div class="imagesCon">
      <img src="https://prod-1251541497.cos.ap-guangzhou.myqcloud.com/activity/images/home.d71719ed.jpg" alt="">
    </div>

    <div class="footerMod">
      <div class="signUp">
        <div class="signUpBtn" @click="signUp">
          <img src="@/assets/image/activity/eitis/button.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {pagebase} from '@/utils/http.js';
  import utils from '@/utils/utils';
  import WxShare from '@/utils/wxshare';

  export default {
    data() {
      return {
        aid: this.$route.query.aid || '',
        activityCon: {},
        arrangeshow: false,
        pagebase: pagebase,
        listShow: false,
      }
    },

    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.showStat();
        // 微信分享
        this.wxshare = new WxShare();
        this.getactivityCon();
      },

      showStat() {
        this.$http({
          url: '/api/showStat',
          method: 'post',
          params: {
            url: window.location.href,
          }
        })
      },

      getactivityCon() {
        this.$http({
          url: '/activity/Info',
          method: 'get',
          params: {
            activity_id: this.aid,
          },
        }).then(res => {
          if (res.code >= 0) {
            let data = res.data;
            this.activityCon = data;
            document.title = data.title;
            this.wxshare.share({
              title: data.title,
              desc: data.summary,
              link: window.location.href,
              imgUrl: data.cover,
            })
          }
        })
      },

      signUp() {
        var succeedUrl = encodeURIComponent(pagebase + '/#/eitiaSucceed?activity_id=' + this.aid);
        if (utils.browserChecker.isWx()) {
          var channel = this.$route.query.channel || '';
          var open = encodeURIComponent(pagebase + '/#/eitiaForm?activity_id=' + this.aid + '&project=' + this.activityCon.project_id + '&channel=' + channel + '&succeed_url=' + succeedUrl);
          var url = 'http://edu.eda365.com/wechat_redirect.php?jump_url=' + open;
          window.location.href = url;
        } else {
          this.$router.push({
            path: '/eitiaForm',
            query: {
              activity_id: this.aid,
              channel: this.$route.query.channel || '',
              project: this.activityCon.project_id,
              track_id: this.$route.query.track_id || '',
              succeed_url: succeedUrl,
            }
          })
        }
      },
    }
  }
</script>

<style lang="css" scoped>
  .hardwareDesign {
    box-sizing: border-box;
    background-color: #0023bf;
  }

  .imagesCon img {
    width: 100%;
    margin-top: -.33rem;
  }

  .footerMod {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 8rem;
    z-index: 10;
  }
  
  .signUp {
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }
  
  .signUpPrice {
    display: flex;
    height: 2rem;
    align-items: flex-end;
  }
  
  .originalCost {
    font-size: 1.6rem;
    color: #FFFFFF;
    margin-right: 1rem;
  }
  
  .originalCost span {
    color: #FFC851;
  }
  
  .currentPrice {
    font-size: 1rem;
    color: #CCCCCC;
  }
  
  .currentPrice span {
    color: #FFFFFF;
  }
  
  .signUpBtn img {
    width: 20rem;
    height: auto;
  }

  @media (min-width: 751px) {    
    .footerMod {
      width: 750px;
      left: 50%;
      margin-left: -375px;
    }
  }
</style>